import { render, staticRenderFns } from "./CircleColour.vue?vue&type=template&id=9e674fa2&"
import script from "./CircleColour.vue?vue&type=script&lang=js&"
export * from "./CircleColour.vue?vue&type=script&lang=js&"
import style0 from "./CircleColour.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports